import React, { Suspense, lazy } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { hideModal } from '../redux/actions/ModalActions';
import './scrollbar.css';

const modalComponents = {
  AddTrainers: lazy(() => import('../admin/trainers/AddTrainers')),
  ChangePassword: lazy(() => import("../auth/ChangePassword")),
  StatusModal: lazy(() => import("./StatusModal")),
  AddStudents: lazy(() => import('../admin/students/AddStudents')),
  BulkAddStudents: lazy(() => import("../admin/students/BulkAddStudents")),
  AddBatch: lazy(() => import("../trainers/batches/AddBatch")),
  LogoutModal: lazy(() => import("./LogoutModal")),
  AssignStudent: lazy(() => import("../trainers/peoples/AddPeople")),
  EditPeople: lazy(() => import("../admin/students/EditStudent")),
  AddSchedule: lazy(() => import("../trainers/schedules/AddSchedule")),
  EditSchedule: lazy(() => import("../trainers/schedules/EditSchedule")),
  AssignTask: lazy(() => import("../trainers/tasks/AddTask")),
  AssignTrainer: lazy(() => import("../trainers/peoples/AssignTrainer")),
  EditTask: lazy(() => import("../trainers/tasks/EditTask")),
  MarksHistory: lazy(() => import("../trainers/marks/MarksHistory")),
  AddMaterial: lazy(() => import("../trainers/materials/AddMaterial")),
  EditMaterial: lazy(() => import("../trainers/materials/EditMaterial")),
  UploadTask: lazy(() => import("../students/tasks/UploadTask")),
  ViewProfile: lazy(() => import("../auth/ViewProfile")),
  // Add more modals here
};

Modal.setAppElement('#root');

const ModalManager = ({ width }) => {
  const dispatch = useDispatch();
  const { isOpen, modalType } = useSelector((state) => state.modal);
  const closeModal = () => {
    dispatch(hideModal());
  };
  if (!width) {
    width = "40vw";
  }
  const ModalComponent = modalComponents[modalType];

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      shouldCloseOnOverlayClick={false} // Prevent closing by clicking outside
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          zIndex: 2000,
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Darker background with opacity
          backdropFilter: 'blur(2px)', // Blur effect
        },
        content: {
          zIndex: 2001,
          width: "40vw", // Set your desired width here
          margin: 'auto',  // Center the modal horizontally
          display: "flex",
          alignItems: "center",
          border: "none",
          background: "transparent",
        }
      }}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <div
            className="custom-scrollbar w-100"
            style={{
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: "20px",
              background: "white",
              borderRadius: "12px",
              boxShadow: "0px 8px 24px rgba(0,0,0,0.2)"
            }}
          >
            {/* <button onClick={closeModal}>Close</button> */}
            {ModalComponent ? <ModalComponent /> : null}
          </div>
        </>
      </Suspense>
    </Modal>
  );
};

export default ModalManager;
